import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Content,
  Top,
  HeaderText,
  Number,
  Title,
  ImageWrapper,
  Image,
  Bottom,
  Info,
} from './style';
import InstagramEmbed from '../InstagramEmbed';

import AppState from '../../states/AppState';
import ListsState from '../../states/ListsState';
import { Header } from '../IntroSlideshow/style';

class ScrollingListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoomed: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.updateBounds);
    window.addEventListener('resize', this.updateBounds);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateBounds);
    window.removeEventListener('resize', this.updateBounds);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.offset !== this.props.offset) {
      this.updateBounds();
    }
  }

  zoomedItemBounds() {
    const { itemIndex, listIndex } = this.props;
    const list = ListsState.lists[listIndex];
    const item = list ? list.items[itemIndex] : null;
    return item ? item.bounds : null;
  }

  popUpScale(inverse) {
    const dimensions = this.popUpDimensions();
    const zoomedItemBounds = this.zoomedItemBounds();
    if (inverse) {
      return dimensions && zoomedItemBounds ? dimensions.width / zoomedItemBounds.width : 1;
    } else {
      return dimensions && zoomedItemBounds ? zoomedItemBounds.width / dimensions.width : 1;
    }
  }

  popUpTranslateX() {
    const zoomedItemBounds = this.zoomedItemBounds();
    return zoomedItemBounds ? ((AppState.windowWidth / 2) - (zoomedItemBounds.left + (zoomedItemBounds.width / 2))) : 0;
  }

  popUpTranslateY() {
    const zoomedItemBounds = this.zoomedItemBounds();
    return zoomedItemBounds ? ((AppState.windowHeight / 2) - (zoomedItemBounds.top + (zoomedItemBounds.height / 2))) : 0;
  }

  popUpTransform() {
    return `translate3d(${this.popUpTranslateX() * -1}px, ${this.popUpTranslateY() * -1}px, 0) scale(${this.popUpScale()})`;
  }

  popUpDimensions() {
    const zoomedItemBounds = this.zoomedItemBounds();
    if (!zoomedItemBounds) return;

    const width = Math.min(AppState.windowWidth, AppState.windowHeight) * 0.8;
    const height = width;
    const margin = `-${height/2}px -${width/2}px`;
    return { height, margin, width };


  }

  imageDimensions() {
    const { item } = this.props;

    if (!item.image) return null;

    const { boxThumbnailArea } = AppState;
    const imageWidth = item.image.full.width;
    const imageHeight = item.image.full.height;
    const relativeSize =  Math.sqrt(boxThumbnailArea / (imageWidth * imageHeight));

    let height = imageHeight * relativeSize * 1.1;
    let width = imageWidth * relativeSize * 1.1;

    return { height, width };
  }

  updateBounds = () => {
    if (!this.wrapper) return;
    const { itemIndex, listIndex } = this.props;
    ListsState.updateBounds(listIndex, itemIndex, this.wrapper.getBoundingClientRect());
  }

  render() {
    const { faded, itemIndex, listIndex, popUp } = this.props;
    const list = ListsState.lists[listIndex];
    const item = list ? list.items[itemIndex] : null;

    return (
      <Wrapper
        className={(item.zoomed && popUp) || (!item.zoomed && !popUp) ? 'active' : 'inactive'}
        faded={faded}
        onClick={(evt) => {
          evt.preventDefault();
          ListsState.toggleZoom(listIndex, itemIndex);
        }}
        innerRef={(el) => {
          if (!this.wrapper && !this.props.popUp) {
            this.wrapper = el;
            this.updateBounds();
          }
        }}
        popUp={popUp}
        style={popUp ? {
          ...this.popUpDimensions(),
          transform: this.popUpTransform(),
        } : {
          height: AppState.boxSize,
          width: AppState.boxSize,
        }}
      >
        <Content>
          <Top>
            <HeaderText
              style={popUp && item.zoomed ? {
                transform: `translate3D(0,0,0) scale(1)`,
              } : popUp && !item.zoomed ? {
                transform: `translate3D(0,0,0) scale(${this.popUpScale(true)})`,
              } : null}  
            >
              <Number>{itemIndex + 1}</Number>
              <Title>{item.label}</Title>
            </HeaderText>
          </Top>
          <ImageWrapper>
            {item.image ? (
              <Image
                src={item.image.full.url}
                height={item.image.full.height}
                width={item.image.full.width}
                style={popUp ? {
                  ...this.imageDimensions(),
                  transform: `scale(${this.popUpScale(true)})`,
                } : this.imageDimensions()}
              />
            ) : item.instaEmbed ? (
              <InstagramEmbed scale={0.6} code={item.instaEmbed} />
            ) : null}
          </ImageWrapper>
          <Bottom>
            <Info
              wrapText={popUp}
              dangerouslySetInnerHTML={{
                __html: item.caption
              }}
            />
          </Bottom>
        </Content>
      </Wrapper>
    );
  }
}

export default observer(ScrollingListItem);



// WEBPACK FOOTER //
// ./src/components/ScrollingListItem/index.js